export function authHeader(leaveBlank) {
  const user = localStorage.getItem("user");
  const userProfile = user ? JSON.parse(user) : null;
  console.log("SDFSF", userProfile.token);
  let result = {
    Authorization: "Bearer " + userProfile.token || undefined,
    Accept: "application/json",
  };
  if (!leaveBlank) {
    result["Content-Type"] = "application/json";
  }
  return result;
}
